import { Module, ActionContext } from 'vuex'
import ajax from '../../lib/ajaxAuth';

interface AccountState{
    tenant: any
}
class AccountStore implements Module<AccountState, any>{
    namespaced = true
    state: AccountState = {
        tenant: null
    }
    actions = {
        async isTenantAvailable(context: ActionContext<AccountState, any>, payload: any){
            let rep = await ajax.post('/Account/IsTenantAvailable', payload.data);
            context.state.tenant = rep.data.result
            return rep.data.result;
        }
    }
}
export default new AccountStore();